import { _ } from "libs";
import React, { Component } from "react";
import { loadFriends, acceptFriendRequest, rejectFriendRequest } from "../actions";
import friendRequestSelector from "../selectors/friendRequestSelector";
import FriendRequest from "./friendRequest";
import { User } from "../types";
import withRedux from "../withRedux";

type Props = {
	loadFriends: Function;
	acceptFriendRequest: Function;
	rejectFriendRequest: Function;
	requests: Array<User>;
};

export class FriendRequestsList extends Component<Props> {
	componentDidMount() {
		this.props.loadFriends();
	}

	render() {
		if (this.props.requests.length > 0) {
			return (
				<div className="oBlock">
					<h5>{_("friendRequests.heading")}</h5>
					<div className="buddyRequests">
						{this.props.requests.map(friend => (
							<FriendRequest
								user={friend}
								key={friend.userId}
								onAccept={this.props.acceptFriendRequest}
								onReject={this.props.rejectFriendRequest}
							/>
						))}
					</div>
				</div>
			);
		} else {
			return null;
		}
	}
}
const mapStateToProps = ({ social: { friends } }, ownProps) => {
	const requests = friendRequestSelector(friends);
	return { requests };
};

export default withRedux(
	{ loadFriends, acceptFriendRequest, rejectFriendRequest },
	mapStateToProps
)(FriendRequestsList);
